export enum LoadingMode {
  VIEW = 'VIEW',
  TABLE = 'TABLE',
  OVERLAY = 'OVERLAY',
  FULLSCREEN = 'FULLSCREEN',
}
